import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
} from "redux/helpers/fetching"
import { fetchPaymentScheduleDates } from "redux/features/payment_schedule_dates/paymentScheduleDatesThunk"

const paymentScheduleDatesAdapter = createEntityAdapter()
export const initialState = paymentScheduleDatesAdapter.getInitialState({
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const paymentScheduleDatesSlice = createSlice({
  name: "payment-schedule-dates",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchPaymentScheduleDates.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchPaymentScheduleDates.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(fetchPaymentScheduleDates.fulfilled, (state, { payload }) => {
        paymentScheduleDatesAdapter.setAll(state, payload.dates)
        handleCollectionFetchFulfilled(state)
      })
  },
})

export const { selectAll: selectPaymentScheduleDates } =
  paymentScheduleDatesAdapter.getSelectors(
    (state: RootState) => state.features.payment_schedule_dates,
  )
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.payment_schedule_dates.fetchCollectionStatus

export default paymentScheduleDatesSlice.reducer
